module.exports = {"statusList":[{"value":1,"name":"待派工"},{"value":2,"name":"已派工"},{"value":3,"name":"已完工"},{"value":4,"name":"已评价"}],"repairRourceList":[{"value":1,"name":"小程序"},{"value":2,"name":"PC端登记"}],"evaluateResultList":[{"value":5,"name":"非常满意"},{"value":4,"name":"比较满意"},{"value":3,"name":"满意"},{"value":2,"name":"一般"},{"value":1,"name":"差"}],"repairResult":[{"value":1,"name":"完工"},{"value":2,"name":"物料不足"},{"value":3,"name":"超出范围"},{"value":4,"name":"其他"}]}


//////////////////
// WEBPACK FOOTER
// ./static/constant.json
// module id = cFIX
// module chunks = 227